// extracted by mini-css-extract-plugin
export var box = "_56-0";
export var check = "_56-1";
export var checkboxButton = "_56-6";
export var checkboxGroup = "_56-5";
export var disabled = "_56-7";
export var ghost = "_56-9";
export var input = "_56-2";
export var label = "_56-4";
export var normal = "_56-8";
export var uncheck = "_56-3";